<template>
   <!-- Columna principal con la tabla -->
      <v-col cols="12">
        
                           <!--  <v-btn
                                color="primary"
                                class="mr-4"
                                type="submit"
                                @click="exportToExcel"
                            >
                                Descargar como Excel
                            </v-btn> -->
                <v-btn class="mr-4 gris_medio" type="submit" @click="exportToExcel">
                  <v-icon left>mdi-file-excel</v-icon> Descargar como Excel
                </v-btn>

      </v-col>
<div class="box">
    <v-row>

      <!-- Columna principal con la tabla -->
      <v-col cols="12">

    <v-typography variant="h1">
      {{$t('resultados.operativos')}} 
    </v-typography>
      </v-col>

    </v-row>

    <v-row>
    
      <v-col cols="12">


  <v-data-table  
  :items="items" 
  :headers="headers" 
  hide-default-footer 
  class='row-height-50' 
  height="550px"
  disable-pagination
  :items-per-page="-1"
  fixed-header>

<template v-slot:[`column.header`]="{ column }">
        <th
          :style="{ backgroundColor: column.color, width: column.width }"
        >
          {{ column.text }}
        </th>
      </template>
      <template v-slot:item="{ item, columns }">
        <tr>
          <td
            v-for="(column, index) in columns"
            :key="index"
            :style="{ backgroundColor: column.color }"
          >
            {{ item[column.value] }}
          </td>
        </tr>
      </template>


    </v-data-table>





      </v-col>


    </v-row>


    <v-row>
      <!-- Columna de margen izquierda -->
      <v-col cols="0"></v-col>

     

      <!-- Columna de margen derecha -->
      <v-col cols="0"></v-col>
    </v-row>


</div>

</template>



<script>

import * as XLSX from 'xlsx';

export default {

  props: {
    items: Object,
  },

 components: {

  },

  data() {
    return {

    headers: [
      { title: 'Hora', value: 'FECHA_HORA', width: "1%" },
      { title: 'Precio electricidad (€/MWh)', value: 'PCIO_EL', width: "1%" },
      { title: 'Demanda (MW)', value: 'DEMV', width: "1%" },
      { title: 'MWh vapor M1', value: 'PV_MCcg1', width: "1%", color:"#E6E6FA" },
      { title: 'MWh vapor M2', value: 'PV_MCcg2', width: "1%", color:"#E6E6FA" },
      { title: 'MWh vapor M3', value: 'PV_MCcg3', width: "1%", color:"#E6E6FA" },
      { title: 'MWh vapor M4', value: 'PV_MCcg4', width: "1%", color:"#E6E6FA" },
      { title: 'MWh vapor M5', value: 'PV_MCcg5', width: "1%", color:"#E6E6FA" },
      { title: 'MWh vapor M6', value: 'PV_MCcg6', width: "1%", color:"#E6E6FA" },
      { title: 'MWh vapor M7', value: 'PV_MCcg7', width: "1%", color:"#E6E6FA" },
      { title: 'MWh vapor M8', value: 'PV_MCcg8', width: "1%", color:"#E6E6FA" },
      { title: 'MWh vapor CV6', value: 'PV_CVcv6', width: "1%", color:"#E6E6FA" },
      { title: 'MWh vapor CV7', value: 'PV_CVcv7', width: "1%", color:"#E6E6FA" },
      { title: 'MWh vapor CV10', value: 'PV_CVcv10', width: "1%", color:"#E6E6FA" },
      { title: 'MWh vapor CE11', value: 'PV_CEce1', width: "1%", color:"#E6E6FA" },
      { title: 'MWh vapor CE12', value: 'PV_CEce2', width: "1%", color:"#E6E6FA" },
      { title: 'MWh frio M1', value: 'PF_MCcg1', width: "1%" },
      { title: 'MWh frio M2', value: 'PF_MCcg2', width: "1%" },
      { title: 'MWh frio M3', value: 'PF_MCcg3', width: "1%" },
      { title: 'MWh frio M4', value: 'PF_MCcg4', width: "1%" },
      { title: 'MWh frio M5', value: 'PF_MCcg5', width: "1%" },
      { title: 'MWh frio M6', value: 'PF_MCcg6', width: "1%" },
      { title: 'MWh frio M7', value: 'PF_MCcg7', width: "1%" },
      { title: 'MWh frio M8', value: 'PF_MCcg8', width: "1%" },
      { title: 'MWh frío COM3', value: 'PF_COMcom3', width: "1%", color:"#E6E6FA" },
      { title: 'MWh frío COM4', value: 'PF_COMcom4', width: "1%", color:"#E6E6FA" },
      { title: 'MWh frío COM5', value: 'PF_COMcom5', width: "1%", color:"#E6E6FA" },
      { title: 'MWh frío COM6', value: 'PF_COMcom6', width: "1%", color:"#E6E6FA" },
      { title: 'MWh frío COM7', value: 'PF_COMcom7', width: "1%", color:"#E6E6FA" },
      { title: 'MWh frío COM8', value: 'PF_COMcom8', width: "1%", color:"#E6E6FA" },
      { title: 'MWh frío COM1 alquiler', value: 'PF_COMcma1', width: "1%", color:"#E6E6FA" },
      { title: 'MWh frío COM2 alquiler', value: 'PF_COMcma2', width: "1%", color:"#E6E6FA" },
      { title: 'MWh frío COM3 alquiler', value: 'PF_COMcma3', width: "1%", color:"#E6E6FA" },
      { title: 'MWh frío COM4 alquiler', value: 'PF_COMcma4', width: "1%", color:"#E6E6FA" },
      { title: 'MWh frío COM5 alquiler', value: 'PF_COMcma5', width: "1%", color:"#E6E6FA" },
      { title: 'MWh consumo gas mercado', value: 'CG_MCDO', width: "1%" },
      { title: 'MWh consumo gas M1', value: 'CG_MCcg1', width: "1%" },
      { title: 'MWh consumo gas M2', value: 'CG_MCcg2', width: "1%" },
      { title: 'MWh consumo gas M3', value: 'CG_MCcg3', width: "1%" },
      { title: 'MWh consumo gas M4', value: 'CG_MCcg4', width: "1%" },
      { title: 'MWh consumo gas M5', value: 'CG_MCcg5', width: "1%" },
      { title: 'MWh consumo gas M6', value: 'CG_MCcg6', width: "1%" },
      { title: 'MWh consumo gas M7', value: 'CG_MCcg7', width: "1%" },
      { title: 'MWh consumo gas M8', value: 'CG_MCcg8', width: "1%" },
      { title: 'MWh consumo gas CV6', value: 'CG_CVcv6', width: "1%" },
      { title: 'MWh consumo gas CV7', value: 'CG_CVcv7', width: "1%" },
      { title: 'MWh consumo gas CV10', value: 'CG_CVcv10', width: "1%" },
      { title: 'MWh consumo elect. CE11', value: 'CE_CEce1', width: "1%", color:"#E6E6FA" },
      { title: 'MWh consumo elect. CE12', value: 'CE_CEce2', width: "1%", color:"#E6E6FA" },
      { title: 'MWh consumo elect. COM3', value: 'CE_COMcom3', width: "1%", color:"#E6E6FA" },
      { title: 'MWh consumo elect. COM4', value: 'CE_COMcom4', width: "1%", color:"#E6E6FA" },
      { title: 'MWh consumo elect. COM5', value: 'CE_COMcom5', width: "1%", color:"#E6E6FA" },
      { title: 'MWh consumo elect. COM6', value: 'CE_COMcom6', width: "1%", color:"#E6E6FA" },
      { title: 'MWh consumo elect. COM7', value: 'CE_COMcom7', width: "1%", color:"#E6E6FA" },
      { title: 'MWh consumo elect. COM8', value: 'CE_COMcom8', width: "1%", color:"#E6E6FA" },
      { title: 'MWh consumo elect. COM1 alquiler', value: 'CE_COMcma1', width: "1%", color:"#E6E6FA" },
      { title: 'MWh consumo elect. COM2 alquiler', value: 'CE_COMcma2', width: "1%", color:"#E6E6FA" },
      { title: 'MWh consumo elect. COM3 alquiler', value: 'CE_COMcma3', width: "1%", color:"#E6E6FA" },
      { title: 'MWh consumo elect. COM4 alquiler', value: 'CE_COMcma4', width: "1%", color:"#E6E6FA" },
      { title: 'MWh consumo elect. COM5 alquiler', value: 'CE_COMcma5', width: "1%", color:"#E6E6FA" },
      { title: 'MWh producción elect. MC1', value: 'PE_MCcg1', width: "1%" },
      { title: 'MWh producción elect. MC2', value: 'PE_MCcg2', width: "1%" },
      { title: 'MWh producción elect. MC3', value: 'PE_MCcg3', width: "1%" },
      { title: 'MWh producción elect. MC4', value: 'PE_MCcg4', width: "1%" },
      { title: 'MWh producción elect. MC5', value: 'PE_MCcg5', width: "1%" },
      { title: 'MWh producción elect. MC6', value: 'PE_MCcg6', width: "1%" },
      { title: 'MWh producción elect. MC7', value: 'PE_MCcg7', width: "1%" },
      { title: 'MWh producción elect. MC8', value: 'PE_MCcg8', width: "1%" }
    ]


      
    };
  },

  mounted() {
   
  },

  methods: {
  normalizarNumeroExcel(valor, decimales = 2) {
    if (valor === "" || valor == null || valor === "-" || valor === "N/A") {
      return "";
    }

    if (typeof valor === "number") {
      if (!Number.isFinite(valor)) return "";
      return Number(valor.toFixed(decimales));
    }

    let texto = String(valor).trim();

    if (texto === "" || texto === "-" || texto === "N/A") return "";

    // Quitar espacios normales y espacios raros de Excel
    texto = texto.replace(/\s/g, "").replace(/\u00A0/g, "");

    // Corrige casos tipo "0," o "20,"
    texto = texto.replace(/[,.]$/, "");

    // Si contiene letras, unidades o símbolos, no lo convertimos
    if (/[a-zA-ZáéíóúÁÉÍÓÚñÑ€%]/.test(texto)) return "";

    // Formato español: "1.234,56"
    if (texto.includes(".") && texto.includes(",")) {
      texto = texto.replace(/\./g, "").replace(",", ".");
    }
    // Formato español simple: "12,34"
    else if (texto.includes(",")) {
      texto = texto.replace(",", ".");
    }
    // Formato miles español sin decimales: "1.234"
    else if (/^-?\d{1,3}(\.\d{3})+$/.test(texto)) {
      texto = texto.replace(/\./g, "");
    }

    const numero = Number(texto);

    if (!Number.isFinite(numero)) return "";

    return Number(numero.toFixed(decimales));
  },

  obtenerFormatoNumeroExcel(valor, decimales = 2) {
    if (typeof valor !== "number" || !Number.isFinite(valor)) {
      return "#,##0";
    }

    const numeroRedondeado = Number(valor.toFixed(decimales));
    const tieneDecimales = !Number.isInteger(numeroRedondeado);

    if (!tieneDecimales) {
      return "#,##0";
    }

    return `#,##0.${"#".repeat(decimales)}`;
  },

  formatearValorExcel(header, valor) {
    if (valor === null || valor === undefined || valor === "" || valor === "N/A") {
      return valor ?? "";
    }

    if (header.value === "FECHA_HORA") {
      return valor;
    }

    const numero = this.normalizarNumeroExcel(valor, 2);
    return numero !== "" ? numero : valor;
  },

  aplicarFormatoCeldaExcelJS(cell, decimales = 2) {
    if (typeof cell.value !== "number") return;

    const numeroRedondeado = Number(cell.value.toFixed(decimales));
    cell.value = numeroRedondeado;

    cell.numFmt = this.obtenerFormatoNumeroExcel(numeroRedondeado, decimales);
  },

  agregarDatosAlWorkbook(sheet) {
    const headers = this.headers.map(h => h.title);

    const datos = this.items.map(item => {
      const row = [];

      this.headers.forEach(h => {
        row.push(this.formatearValorExcel(h, item[h.value]));
      });

      return row;
    });

    sheet.columns = headers.map(h => ({
      header: h,
      width: 25,
    }));

    datos.forEach(row => {
      const fila = sheet.addRow(row);

      fila.eachCell((cell, colNumber) => {
        const header = this.headers[colNumber - 1];

        if (!header) return;

        if (header.value !== "FECHA_HORA") {
          this.aplicarFormatoCeldaExcelJS(cell, 2);
        }

        cell.alignment = {
          vertical: "middle",
          horizontal: "center"
        };
      });
    });
  },

  exportToExcel() {
    const wb = XLSX.utils.book_new();

    const headerTitles = this.headers.map(header => header.title);

    const filteredItems = this.items.map(item => {
      const filteredItem = {};

      this.headers.forEach(header => {
        filteredItem[header.title] = this.formatearValorExcel(
          header,
          item[header.value]
        );
      });

      return filteredItem;
    });

    const ws = XLSX.utils.json_to_sheet(filteredItems, {
      header: headerTitles
    });

    const wsCols = headerTitles.map(() => ({ wch: 25 }));
    ws["!cols"] = wsCols;

    // Aplicar formato numérico en la descarga individual con XLSX
    const range = XLSX.utils.decode_range(ws["!ref"]);

    for (let R = range.s.r + 1; R <= range.e.r; R++) {
      this.headers.forEach((header, index) => {
        const C = index;
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = ws[cellAddress];

        if (!cell || typeof cell.v !== "number") return;

        if (header.value !== "FECHA_HORA") {
          const numeroRedondeado = Number(cell.v.toFixed(2));

          cell.v = numeroRedondeado;
          cell.t = "n";
          cell.z = this.obtenerFormatoNumeroExcel(numeroRedondeado, 2);
        }
      });
    }

    XLSX.utils.book_append_sheet(wb, ws, "Resultados operación");

    XLSX.writeFile(wb, "resultados-operacion.xlsx");
  }
}
};
</script>










<style>
.v-data-table.row-height-50 td
{
  height: 18px !important;
  font-size:8px

}

.v-data-table.row-height-50 th
{
  height: 18px !important;
  font-size:8px
}


.red-cell {
  background-color: red;
  color: white;
}

.green-cell {
  background-color: green;
  color: white;
}

.box {
    margin: 20px; /* Margen en los cuatro lados */
    padding: 10px;

  }


</style>
